import { useState, useEffect } from 'react';
import './../../pagescss/Page.css'; // Importing your CSS styles here

const images = [
    {
        src: "bookimg/1.jpg",
        alt: "Mountain landscape"
    },
    {
        src: "bookimg/2.jpg",
        alt: "Forest path"
    },
    {
        src: "bookimg/3.jpg",
        alt: "Forest trees"
    },
    {
        src: "bookimg/4.jpg",
        alt: "Green field"
    }



];

function App() {
    return (
        <div style={{ padding: '0px', fontFamily: 'sans-serif' }}>

            {/* Renders all images side-by-side in a row without navigation controls */}
            <div className="image-row-container">
                {images.map((image, index) => (
                    <LazyImage
                        key={index}
                        src={image.src}
                        alt={image.alt}
                    />
                ))}
            </div>
        </div>
    );
}

// LazyImage component handles individual image loading states
function LazyImage({ src, alt }) {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        setIsLoaded(false);
    }, [src]);

    return (
        <div className="image-wrapper">
            {!isLoaded && (
                <div className="loader-container">
                    <div className="circle-loader" />
                </div>
            )}

            <img
                src={src}
                alt={alt}
                className={`lazy-image ${isLoaded ? 'loaded' : ''}`}
                onLoad={() => setIsLoaded(true)}
            />
        </div>
    );
}

export default App;